import { useEffect } from 'react';

const SEO = ({ 
  title,
  description,
  image,
  url,
  type = 'website',
  author,
  keywords,
  twitterCard = 'summary_large_image',
  siteName = 'VibrantCast',
  locale = 'en_US'
}) => {
  // Default values
  const defaultTitle = 'VibrantCast - Discover and Connect with Amazing Artists';
  const defaultDescription = 'VibrantCast is a platform connecting artists, galleries, collectors, and art enthusiasts. Discover amazing artwork, explore virtual galleries, and connect with the vibrant art community.';
  const defaultImage = `${window.location.origin}/images/logo-120.png`;
  const defaultUrl = window.location.href;

  // Use provided values or defaults
  const seoTitle = title || defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;
  const seoUrl = url || defaultUrl;

  useEffect(() => {
    // Update document title
    document.title = seoTitle;

    // Update meta tags
    const updateMetaTag = (name, content, property = false) => {
      if (content) {
        let meta = document.querySelector(`meta[${property ? 'property' : 'name'}="${name}"]`);
        if (!meta) {
          meta = document.createElement('meta');
          if (property) {
            meta.setAttribute('property', name);
          } else {
            meta.setAttribute('name', name);
          }
          document.head.appendChild(meta);
        }
        meta.content = content;
      }
    };

    // Update primary meta tags
    updateMetaTag('title', seoTitle);
    updateMetaTag('description', seoDescription);
    if (keywords) updateMetaTag('keywords', keywords);
    if (author) updateMetaTag('author', author);

    // Update Open Graph tags
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:url', seoUrl, true);
    updateMetaTag('og:title', seoTitle, true);
    updateMetaTag('og:description', seoDescription, true);
    updateMetaTag('og:image', seoImage, true);
    updateMetaTag('og:site_name', siteName, true);
    updateMetaTag('og:locale', locale, true);

    // Update Twitter tags
    updateMetaTag('twitter:card', twitterCard, true);
    updateMetaTag('twitter:url', seoUrl, true);
    updateMetaTag('twitter:title', seoTitle, true);
    updateMetaTag('twitter:description', seoDescription, true);
    updateMetaTag('twitter:image', seoImage, true);

    // Update additional meta tags
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('googlebot', 'index, follow');
    updateMetaTag('format-detection', 'telephone=no');

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = seoUrl;

  }, [seoTitle, seoDescription, seoImage, seoUrl, type, author, keywords, twitterCard, siteName, locale]);

  return null; // This component doesn't render anything
};

export default SEO;
